"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Priority_4_Operator = exports.Priority_3_Operator = exports.Priority_2_Operator = exports.Priority_1_Operator = exports.AllOperators = exports.Operators = exports.ArithmeticOperator = exports.ComparisonOperator = exports.BackslashOperator = exports.QuestionMarkOperator = exports.ColonOperator = exports.ParenthesisCloseOperator = exports.ParenthesisOpenOperator = exports.AssignmentOperator = exports.NotEqualOperator = exports.EqualOperator = exports.LessThanOrEqualOperator = exports.GreaterThanOrEqualOperator = exports.LessThanOperator = exports.GreaterThanOperator = exports.LogicalOrOperator = exports.LogicalAndOperator = exports.ModuloOperator = exports.ExponentialOperator = exports.MultiplicationOperator = exports.DivisionOperator = exports.SubtractionOperator = exports.AdditionOperator = exports.ConditionResult = exports.REGEX = void 0;
exports.REGEX = {
    formulaOperatorG: /(<=|\^|%|>=|==|\|\||&&|!=|[+/\-*=()<>?:])/g,
    formulaOperator: /(<=|>=|\^|%|==|\|\||&&|!=|[+/\-*=()<>?!:])/,
    formulaFieldName: /f_[\w]/, // that is regex that identify the formula fieldName
};
exports.ConditionResult = {
    True: 1,
    False: 0,
};
// Arithmetics operators
exports.AdditionOperator = "+";
exports.SubtractionOperator = "-";
exports.DivisionOperator = "/";
exports.MultiplicationOperator = "*";
exports.ExponentialOperator = "^";
exports.ModuloOperator = "%";
// Logics operators
exports.LogicalAndOperator = "&&";
exports.LogicalOrOperator = "||";
// Comparisons operators
exports.GreaterThanOperator = ">";
exports.LessThanOperator = "<";
exports.GreaterThanOrEqualOperator = ">=";
exports.LessThanOrEqualOperator = "<=";
exports.EqualOperator = "==";
exports.NotEqualOperator = "!=";
// Others operators
exports.AssignmentOperator = "=";
exports.ParenthesisOpenOperator = "(";
exports.ParenthesisCloseOperator = ")";
exports.ColonOperator = ":";
exports.QuestionMarkOperator = "?";
exports.BackslashOperator = "\\";
exports.ComparisonOperator = [
    exports.GreaterThanOperator,
    exports.LessThanOperator,
    exports.LogicalOrOperator,
    exports.LogicalAndOperator,
    exports.GreaterThanOrEqualOperator,
    exports.LessThanOrEqualOperator,
    exports.EqualOperator,
    exports.NotEqualOperator,
];
exports.ArithmeticOperator = [
    exports.AdditionOperator,
    exports.SubtractionOperator,
    exports.DivisionOperator,
    exports.MultiplicationOperator,
    exports.ExponentialOperator,
    exports.ModuloOperator,
];
exports.Operators = [
    ...exports.ArithmeticOperator,
    ...exports.ComparisonOperator,
    exports.QuestionMarkOperator,
];
exports.AllOperators = [
    ...exports.Operators,
    exports.ColonOperator,
    exports.ParenthesisCloseOperator,
    exports.ParenthesisOpenOperator,
];
exports.Priority_1_Operator = [exports.AdditionOperator, exports.SubtractionOperator];
exports.Priority_2_Operator = [
    exports.DivisionOperator,
    exports.MultiplicationOperator,
    exports.ModuloOperator,
];
exports.Priority_3_Operator = [exports.ExponentialOperator];
exports.Priority_4_Operator = [
    ...exports.ComparisonOperator,
    exports.QuestionMarkOperator,
];
